<template>
  <q-btn
    type="submit"
    v-bind="attrs"
    unelevated
    :label="hasDefaultSlot ? undefined : $maybeT(label)"
    @click.prevent="$emit('submit', $event)"
    @keyup.enter.prevent="$emit('submit', $event)"
  >
    <slot name="tooltip">
      <q-tooltip v-if="tooltip && tooltip.length">
        {{ attrs.loading && inProgressTooltip ? inProgressTooltip : tooltip }}
      </q-tooltip>
    </slot>

    <slot v-if="hasDefaultSlot"></slot>

    <template #loading>
      <q-circular-progress v-if="useProgressEvent" :value="progressPercentage" color="white" />

      <q-spinner-facebook v-else />
    </template>
  </q-btn>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  inheritAttrs: false,
  name: 'ProgressButton',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    label: {
      type: String,
      default: '$t__general.submit_button_label',
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    inProgressTooltip: {
      type: String,
      default: undefined,
    },
    useProgressEvent: {
      type: Boolean,
      default: false,
    },
    progressEventType: {
      type: String,
      default: 'download',
      validator(type) {
        const isValid = ['download', 'upload'].includes(type);
        if (!isValid) {
          console.warn(
            'ProgressButton: "progressEventType" prop should be either "download" or "upload"'
          );
        }
        return isValid;
      },
    },
  },

  computed: {
    attrs() {
      return {
        ...this.$attrs,
        color: this.color,
      };
    },

    ...mapGetters(['getHttpProgress']),

    progressPercentage() {
      return this.getHttpProgress[this.progressEventType] * 100;
    },

    hasDefaultSlot() {
      return (
        typeof this.$slots.default?.[0].text === 'string' && this.$slots.default?.[0].text.length
      );
    },
  },
};
</script>
